import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_ecomsync_branch_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_branch_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: {};
  log_json: fromDatatype.JsonDatatypeInterface;
  qty_buffer: fromDatatype.NumericDatatypeInterface;
  percentage: fromDatatype.NumericDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  branch_list: fromDatatype.JsonDatatypeInterface;
  sales_order_list: fromDatatype.JsonDatatypeInterface;
  mode_config: fromDatatype.TextDatatypeInterface;
  sales_order_config: fromDatatype.TextDatatypeInterface;
  buffer_config: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  stock_mode: fromDatatype.TextDatatypeInterface;
  override_item_stock_config: fromDatatype.TextDatatypeInterface;

}

export class bl_fi_mst_ecomsync_branch_RowClass
  implements bl_fi_mst_ecomsync_branch_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    fi_branch_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: {};
    log_json: fromDatatype.JsonDatatypeInterface;
    qty_buffer: fromDatatype.NumericDatatypeInterface;
    percentage: fromDatatype.NumericDatatypeInterface;
    qty_balance: fromDatatype.NumericDatatypeInterface;
    branch_list: fromDatatype.JsonDatatypeInterface;
    sales_order_list: fromDatatype.JsonDatatypeInterface;
    mode_config: fromDatatype.TextDatatypeInterface;
    sales_order_config: fromDatatype.TextDatatypeInterface;
    buffer_config: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    stock_mode: fromDatatype.TextDatatypeInterface;
    override_item_stock_config: fromDatatype.TextDatatypeInterface;
}
